/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins';

// Components
import { registerGlobalComponents } from '@/plugins/global-components';
import { createApp } from 'vue';
import App from './App.vue';

// Composables
const app = createApp(App);
registerGlobalComponents(app);

registerPlugins(app);

app.mount('#app');
